import { render, staticRenderFns } from "./class-tender.vue?vue&type=template&id=48f7f050&scoped=true"
import script from "./class-tender.vue?vue&type=script&setup=true&lang=js"
export * from "./class-tender.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-progress/dist/vue-progress.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./class-tender.vue?vue&type=style&index=1&id=48f7f050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7f050",
  null
  
)

export default component.exports